export default "__VITE_ASSET__AiysZlS5__"